import jsCookie from 'js-cookie';
import md5 from 'js-md5';
import { sha256 } from 'js-sha256';
import { raygun } from '@ynap/clientside-monitoring';

const userAuthenticationStatusMap = {
    Full: 'logged in',
    Partial: 'recognized',
};

export default async () => {
    const response = {
        profile: { profileInfo: {} },
        attributes: { logged: 'anonymous' },
    };

    try {
        const {
            parentCustomerURN,
            personalizationID,
            hasOrder,
            customerSegments,
            userAuthenticationStatus,
            email1,
            receiveEmailPreference,
            gender,
            designerPreferences = [],
            customerURN,
        } = (await window.SF.getUserSummary()) || {};

        if (parentCustomerURN) {
            const { customerLevelOfService, customerCategory, marketingSegments } = customerSegments;
            const yorbRdCookieValue = jsCookie.get('yOrbRD');

            const getSegments = (segments, multiple = false, forceUpperCase) =>
                (segments || []).reduce(
                    (acc, { customerSegmentName: name, id }) => {
                        if (multiple) {
                            return {
                                name: [...acc.name, forceUpperCase ? name.toUpperCase() : name],
                                id: [...acc.id, id],
                            };
                        }
                        return { name: forceUpperCase ? name.toUpperCase() : name, id };
                    },
                    multiple ? { name: [], id: [] } : { name: null, id: null },
                );

            response.profile = {
                profileInfo: {
                    profileID: parentCustomerURN.split(':')[3],
                    returningStatus: hasOrder === 'true' ? 'existing' : 'new',
                    emailMD5: md5(email1),
                    emailSHA256: sha256(email1),
                    customerID: customerURN,
                },
            };
            if (yorbRdCookieValue) {
                response.profile.profileInfo.yorbId = yorbRdCookieValue;
            }
            response.attributes = {
                personalisationID: personalizationID,
                segment: getSegments(marketingSegments, true),
                category: getSegments(customerCategory, false, true),
                class: getSegments(customerLevelOfService, false),
                logged: userAuthenticationStatusMap[userAuthenticationStatus],
                gender,
                espID: parentCustomerURN,
                customerURN,
                emailMarketing: receiveEmailPreference === 'true',
                preferences: {
                    designerList: designerPreferences?.map((designer) => designer?.name),
                },
            };
        }
    } catch (e) {
        // TODO: We have a race condition whereby SF.getUserSummary is not always ready, just send back empty response
        raygun.helpers.agent('send', {
            error: new Error(`Retrieving user data failed`),
            tags: ['error-analytics-get-user-failed'],
            customData: {
                message: 'Retrieving user data failed',
                err: e,
            },
        });
    }

    return response;
};
